import React from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { adminAPI } from '../../../api';

import useModal from '../../../context/ModalContext';
import useAlarm from '../../../context/AlarmContext';
import FormLoader from '../../../components/FormLoader';

const ResendInviteModal = ({ 
  items, 
  setItems, 
  checkedAllUsers, 
  totalUsers,
  filter,
  searchQuery,
  handleSelectAllUsers,
}) => {
  const { setAlarm } = useAlarm();
  const { setContent, closeModal } = useModal();

  const bulkEmailLimit = parseInt(window.ENV?.BULK_EMAIL_LENGTH || process.env.REACT_APP_BULK_EMAIL_LENGTH || '1', 10);

  const queryClient = useQueryClient();

  const { mutate, isLoading: mutationIsLoading } = useMutation(
    adminAPI.resendInvites,
    {
      onSuccess: (data) => {
        setAlarm({ type: 'success', message: data.message });
        setContent({ title: null, body: null });
        setItems([]);
        handleSelectAllUsers(false); // Desmarca checkedAllUsers e limpa itens selecionados
        queryClient.invalidateQueries('pendingInvites');
        closeModal();
      },
      onSettled: (data, error) => {
        if (error) {
          setAlarm({ type: 'error', message: error.message });
          closeModal();
        }
      },
    }
  );

  const handleSubmit = (event) => {
    event.preventDefault();

    let dataToSend;

    if (checkedAllUsers === true && totalUsers > bulkEmailLimit) {
      // For bulk operations, merge updateData with items
      dataToSend = {
        selectAll: checkedAllUsers === true ? true : false,
        searchQuery: searchQuery,
        filter: filter
      };
    } else {
      // For individual items, send items directly
      dataToSend = items;
    }

    const serializedData = JSON.stringify(dataToSend);
    mutate(serializedData);
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <h2 className=" font-semibold">Resend Invites</h2>
        {checkedAllUsers ? (
          <p>You are resending invitation emails to all {totalUsers.toLocaleString('en-US')} users.</p>
        ) : (
          <>
          <p>You are resending invitation emails to the following users.</p>
          <div
            style={{ maxHeight: '400px' }}
            className="border-2 border-gray rounded-2lg p-4 overflow-y-scroll my-8"
          >
            {items.map((item) => (
              <p key={item.email}>{item.email}</p>
            ))}
          </div>
          </>
        )}

        <button
          type="submit"
          className=" font-semibold p-4 rounded-lg bg-green-light text-white mt-4"
        >
          Resend Invites
        </button>
      </form>
      {mutationIsLoading && <FormLoader />}
    </>
  );
};

export default ResendInviteModal;
 